import { render, staticRenderFns } from "./TitledList.vue?vue&type=template&id=771671ec&scoped=true&"
import script from "./TitledList.vue?vue&type=script&lang=ts&"
export * from "./TitledList.vue?vue&type=script&lang=ts&"
import style0 from "./TitledList.vue?vue&type=style&index=0&id=771671ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771671ec",
  null
  
)

export default component.exports